import { LocationNumbersService } from "../../../services"

const fetchRegulatoryAddresses = async function ({ commit }, payload) {
  try {
    const { data } = await LocationNumbersService.getRegulatoryAddresses(
      payload
    )

    commit('setRCAddressList', data)

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }

}

export default fetchRegulatoryAddresses
